import styled, { css } from 'styled-components';
import { getColorAlias, getFontSize, getSpacing } from '../../utils/index.js';
import { defaultProps } from './defaultProps.js';
import { TableCell } from './components/TableCell.js';

const BUTTON_SIZE = defaultProps.buttonSize;
const getColor = (theme, variant) => {
    return variant === 'primary'
        ? // TODO: RUI-19 there isn't a color alias for this as of now
            theme.mode === 'light'
                ? theme.global.blue60
                : theme.global.blue30
        : getColorAlias('contentDefault', theme);
};
const TableContainer = styled.table `
  ${({ theme }) => `
    width: 100%;
    border-collapse: collapse;
    border-radius: ${theme.radius.roundedB};
    text-align: left;
  `}
`;
const HeadContainer = styled.thead `
  ${({ theme }) => css `
    border-bottom: 1px solid
      rgba(${theme.mode === 'light' ? '0, 0, 0' : '255, 255, 255'}, 0.08);
    width: 100%;
    color: ${getColorAlias('contentSubdued')};
  `}
`;
const Header = styled.th `
  ${({ hasIcon, theme, width }) => `
    width: ${width}%;
    position: relative;
    align-items: center;
    padding: 14px 16px;
    ${getFontSize('size14')};
    font-family: ${theme.font.familyPrimary};
    font-weight: ${theme.font.weightBold};
    span {
      vertical-align: ${hasIcon ? 'sub' : 'initial'};
      margin-right: ${hasIcon ? '20' : '0'}px;
    }
  `}
`;
const Cell = styled.td `
  ${({ theme, align, variant }) => `
    position: relative;
    align-items: center;
    box-sizing: border-box;
    flex-shrink: 0;
    flex-grow: 0;
    padding: 14px 16px;
    font-family: ${theme.font.familyPrimary};
    ${getFontSize('size14')};
    text-align: ${align};
    color: ${getColor(theme, variant)};
  `}
`;
const HeaderRowContainer = styled.tr `
  width: 100%;
  cursor: default;
  &:hover {
    background-color: transparent;
  }
`;
const FooterRowContainer = HeaderRowContainer;
const RowContainer = styled.tr `
  border-bottom: 1px solid ${getColorAlias('disabled01')};
  width: 100%;
  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
  cursor: pointer;
`;
const PaginationContainer = styled.div `
  padding: ${getSpacing('s02')};
`;
const TablePaginationCell = styled(TableCell) `
  padding: 6px 8px;
`;
const TablePaginationContainer = styled.tfoot `
  width: 100%;
`;
const Button = styled.button `
  ${({ theme, isSelected, hasOnClick, isPagination, disabled }) => css `
    height: ${BUTTON_SIZE}px;
    width: ${BUTTON_SIZE}px;
    border-radius: 100%;
    border: none;
    ${getFontSize('size12')};
    font-weight: ${theme.font.weightBold};
    background-color: ${isSelected
    ? getColorAlias('interactivePrimary')
    : 'transparent'};
    color: ${isSelected
    ? getColorAlias('contentInteractivePrimary')
    : getColorAlias('contentInteractiveTertiary')};
    &:hover {
      background-color: ${hasOnClick && !isSelected
    ? 'rgba(0, 0, 0, .08)'
    : hasOnClick
        ? getColorAlias('interactivePrimary')
        : 'transparent'};
    }
    cursor: ${hasOnClick && !isSelected ? 'pointer' : 'default'};
    margin-right: 8px;
    &:last-of-type {
      margin-right: 0;
    }
    float: ${!isPagination ? 'right' : undefined};
    svg {
      fill: ${isPagination
    ? disabled
        ? getColorAlias('contentDisabled')
        : getColorAlias('contentInteractiveTertiary')
    : getColorAlias('contentSubdued')};
    }
  `}
`;
const NextPreviousPage = styled.span `
  ${({ direction }) => `
    margin-${direction === 'next' ? 'left' : 'right'}: 20px;
  `}
`;

export { Button, Cell, FooterRowContainer, HeadContainer, Header, HeaderRowContainer, NextPreviousPage, PaginationContainer, RowContainer, TableContainer, TablePaginationCell, TablePaginationContainer };
